import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import ObjectivesAdd from './../../elements/objectives/widget/objectives_add';
import ObjectivesSearch from './../../elements/objectives/widget/objectives_search';

class ProigualdadObjectives extends Component {
	render() {
		return (
			<ObjectivesList {...this.props} />
		)
	}

	componentWillMount() {
		this.props.objectivesShow(this.props.objectives.pages.current);
	}
}

export class ObjectivesList extends Component {
	render() {
		let { objectives } = this.props;

		let ou = _.find(objectives.permissions, (o) => {return o==='Update'});
		let od = _.find(objectives.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{objectives.isFetching ? <Loading /> :
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Código</th>
							<th>Nombre</th>
						</tr>
						</thead>
						<tbody>
						{_.map(objectives.list, (row, k) => {
							return (
								<tr key={k}>
									<td style={{width:'80px'}}>
										<div className="actions">
											{ou ? <NavLink to={`/proigualdad/objetivos/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
											{od ? <button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td>{row.code}</td>
									<td><strong>{row.name}</strong></td>
								</tr>
							)
						})}
						</tbody>
					</table>}
				{objectives.pages.total>20 &&
				<InmPagination key="objectives-pages"
				               current={objectives.pages.current}
				               total={objectives.pages.total}
				               nextPage={this._handlePageChange}/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		const { objectives } = this.props;
		this.props.objectivesShow(value, objectives.filters);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el objetivo "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.objectiveDelete(id)
		})
	}
}

export default BaseLayout(ProigualdadObjectives, {
	title:"Objetivos Proigualdad",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <ObjectivesSearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <ObjectivesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/objectives/index.jsx